module.exports = __webpack_public_path__ + "img/smoked.6028f57d.png";